// 通常HTMLで最初に観測した流入をタブ内だけに保持し、電話確定前のDB保存をなくす。
(function () {
  'use strict';
  var key = 'yeay_mcv_first_landing_v1';
  var path = window.location.pathname;
  var excluded = /^\/(operator|api)(\/|$)/.test(path) ||
    /^\/form\/in\/(sms|chat\/v3)(\/|$)/.test(path) ||
    new URLSearchParams(window.location.search).get('ui_preview') === '1' ||
    navigator.userAgent === 'ELB-HealthChecker/2.0';
  if (excluded || window.YeayMcvLanding) return;

  // タブ内で最初に観測したURLを固定し、内部遷移・再読み込みで上書きしない。
  // storage拒否・破損時は現在ページから元流入を推測せず、回答保存だけを継続する。
  var first = null;
  try {
    var storage = window.sessionStorage;
    var raw = storage.getItem(key);
    if (raw === null) {
      first = {
        version: 1,
        url: window.location.href,
        landed_at: new Date().toISOString(),
        referer: document.referrer || ''
      };
      raw = JSON.stringify(first);
      // 捕捉不能だった事実も残し、次の短いURLを初回流入として採用しない。
      if (raw.length > 32768) {
        first = null;
        raw = JSON.stringify({ version: 1, rejected: true });
      }
      storage.setItem(key, raw);
    } else if (raw.length <= 32768) {
      var value = JSON.parse(raw);
      if (value && value.version === 1 && typeof value.url === 'string' &&
          typeof value.landed_at === 'string' && typeof value.referer === 'string') first = value;
    }
  } catch (_) {
    first = null;
  }

  // 候補登録と後続回答で同じスナップショットを返し、Cookie・解析タグには渡さない。
  window.YeayMcvLanding = {
    read: function () { return first ? JSON.stringify(first) : null; }
  };
})();



//////////////////
// WEBPACK FOOTER
// ./app/assets/javascripts/mcv_landing.js
// module id = 0
// module chunks = 29